<script>
    export default {
        name: 'AppStore',
        props: {
            application: {
                required: true,
                type: Object
            },
            options: {
                required: true,
                type: Object
            },
            user: {
                required: true,
                type: Object
            },
            token: {
                required: true,
                type: String
            },
            adminToken: {
                required: true,
                type: String
            }
        },

        mounted() {
            // application
            this.$appStore.application.set(this.application)

            // options
            this.$appStore.options.set(this.options)

            // auth
            this.$appStore.auth.user.set(this.user)
            this.$appStore.auth.setToken(this.token)
            this.$appStore.auth.setAdminToken(this.adminToken)
        },

        render() {

        }
    };

</script>

<style lang="scss" scoped>

</style>
